import useSWR from "swr";
import { PaymentStatusResponse } from "../types";

export const usePaymentStatus = (paymentId?: string | number) => {
    const methods = useSWR<PaymentStatusResponse>(paymentId ? `payment/${paymentId}/status` : null);
    return methods;
};
